import {Component, ChangeDetectionStrategy, inject} from '@angular/core';
import {TableModule} from 'primeng/table';
import {DatePipe, JsonPipe} from '@angular/common';
import {resource} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {DomainEventService} from '../../services/domain-event.service';

@Component({
  standalone: true,
  selector: 'app-domain-events-page',
  imports: [TableModule, JsonPipe, DatePipe],
  templateUrl: './domain-events-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DomainEventsPageComponent {
  private readonly domainEventService = inject(DomainEventService);

  protected readonly events = resource({
    request: () => ({}),
    loader: () => firstValueFrom(this.domainEventService.getAllDomainEvents())
  });
}
